import React from "react";
import { Modal, Collapse, Tooltip, Popover, Divider } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import { ModalButton } from "../baseComponents";
import { errorLayersDescMap, errorLayersFixDescMap } from "../../utils/errors";
import {
  ArrowRight,
  ErrorWarningIcon,
  InfoIcon,
  WarningIcon,
} from "../baseComponents/Icons";
import { combineErrors } from "../../store/utils/combineErrors";
import { pluralize } from "../../store/utils/Pluralize";
import { ModalTopBar } from "./ModalTopBar";
const { Panel } = Collapse;

enum ErrorNameMapping {
  Wav = "Wav",
  AudOffset = "Audio Offset",
  AudLock = "Audio Lock",
  VidTrack = "Video Track",
  CompCollapse = "Composition Collapse",
  TextDeformed = "Text Deformed",
  LayerLocked = "Layer Locked",
  UnsupportedFormat = "Unsupported Format",
  NameError="Name",
  UnknownError = "Unknown Error",
  FontError = "Fonts",
}

export const ProblemLayers = observer(() => {
  const {
    uiStore: {
      problemLayersModalVisible,
      setProblemLayersModalHidden,
      getProblemLayers,
    },
  } = useMst();
  const problemLayers = getProblemLayers();
  const problemLayersData = combineErrors(problemLayers);
  const infoContent = (name: string) => (
    <div style={{ backgroundColor: "#FABB36" }}>
      <div style={{display:'flex', marginRight:'0.5rem'}}>
      <div style={{ color: "black", marginRight:'1rem' }}>
        <WarningIcon />
      </div>
      <h3 style={{ fontSize: "10px", fontWeight: "bold" }}>
        {errorLayersDescMap.get(name)}
      </h3>
      </div>
      <Divider />
      <p style={{ fontSize: "10px", color: "black" }}>
        {errorLayersFixDescMap.get(name)}
      </p>
    </div>
  );
  return (
    <Modal
      className={[styles.Modal, styles.ProblemLayers].join(" ")}
      visible={problemLayersModalVisible}
      onOk={() => setProblemLayersModalHidden}
      onCancel={setProblemLayersModalHidden}
      footer={false}
    >
      <ModalTopBar icon={<ErrorWarningIcon />} />
      <h2 className={styles.Header}>Oops, looks like we have some errors</h2>
      <Collapse bordered={false} ghost>
        {problemLayers.length &&
          Object.entries(problemLayersData)
            .filter(([type, data]) => data?.length !== 0)
            .map(([type, data]) => (
              <Panel header={ErrorNameMapping[type as keyof typeof ErrorNameMapping]} key={type}>
                {data.map(({ name, text }) =>
                  text.map((text) => (
                    <div key={text} className={styles.Information}>
                      <p className={styles.Left} key={text} title={text ? `${name} >>  ${text}` : name}>
                        {text ? `${name} >>  ${text}` : name}
                      </p>
                      <Popover
                        placement="left"
                        key={text}
                        content={infoContent(type)}
                        className={styles.Right}
                        overlayClassName={styles.overlayClassName}
                      >
                        <div>
                          <InfoIcon />
                        </div>
                      </Popover>
                    </div>
                  ))
                )}
              </Panel>
            ))}
      </Collapse>


      <div className={styles.Buttons}>
        <ModalButton onClick={setProblemLayersModalHidden} text="Ok" />
      </div>
    </Modal>
  );
});
